'use client';
import dynamic from 'next/dynamic';

export const ToasterContainerDynamic = dynamic(() => import('./ToasterContainer').then((mod) => mod.ToasterContainer), {
  ssr: false,
});
